import { useEffect, useState } from "react";
import { Megaphone, X } from "lucide-react";
import api from "@/services/api";

export default function FlashBanner() {
  const [flash, setFlash] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    let mounted = true;
    const load = () => {
      api.getFlash()
        .then((data) => { if (mounted) setFlash(data); })
        .catch(() => {});
    };
    load();
    const id = setInterval(load, 60_000); // poll every minute
    return () => { mounted = false; clearInterval(id); };
  }, []);

  if (!flash || dismissed) return null;
  const colors = {
    info: { bg: "rgba(59,130,246,0.95)", fg: "#fff" },
    warning: { bg: "rgba(234,179,8,0.95)", fg: "#000" },
    success: { bg: "rgba(34,197,94,0.95)", fg: "#000" },
  };
  const c = colors[flash.severity] || colors.info;
  return (
    <div data-testid="flash-banner" style={{
      position: "fixed", top: 0, left: 0, right: 0,
      backgroundColor: c.bg, color: c.fg,
      padding: "10px 16px",
      zIndex: 10000,
      display: "flex", alignItems: "center", gap: "10px",
      boxShadow: "0 2px 12px rgba(0,0,0,0.3)",
      fontSize: "13px", fontWeight: 600,
    }}>
      <Megaphone size={16} />
      <span style={{ flex: 1 }}>{flash.text}</span>
      <button
        onClick={() => setDismissed(true)}
        data-testid="flash-dismiss-btn"
        style={{ background: "none", border: "none", color: c.fg, cursor: "pointer", padding: "4px" }}
        aria-label="Fermer"
      >
        <X size={16} />
      </button>
    </div>
  );
}
